import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 10.5,
					height: 6,
					rx: 1,
					fill: "#14120F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.49929 12.5V12.0893L4.13246 9.79778H2.49609V9.22729H5.00178V9.63798L3.36701 11.9295H5.00497V12.5H2.49929Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.31785 9.22729V12.5H5.62591V9.22729H6.31785Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.97714 12.5V9.22729H8.26833C8.51656 9.22729 8.72803 9.2747 8.90274 9.36952C9.07746 9.46327 9.21063 9.59377 9.30225 9.76103C9.39493 9.92722 9.44127 10.119 9.44127 10.3363C9.44127 10.5536 9.3944 10.7454 9.30065 10.9116C9.2069 11.0778 9.07107 11.2072 8.89316 11.2999C8.71631 11.3926 8.50218 11.4389 8.25076 11.4389H7.42778V10.8844H8.1389C8.27206 10.8844 8.38179 10.8615 8.46809 10.8157C8.55544 10.7688 8.62043 10.7044 8.66304 10.6224C8.70672 10.5393 8.72856 10.4439 8.72856 10.3363C8.72856 10.2277 8.70672 10.1328 8.66304 10.0519C8.62043 9.96984 8.55544 9.90645 8.46809 9.86171C8.38073 9.8159 8.26993 9.79299 8.1357 9.79299H7.66908V12.5H6.97714Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 14,
					height: 8,
					rx: 1.5,
					fill: "#14120F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.33239 18.5V17.9524L5.50994 14.897H3.32812V14.1364H6.66903V14.6839L4.48935 17.7393H6.6733V18.5H3.33239Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.4238 14.1364V18.5H7.50121V14.1364H8.4238Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.30286 18.5V14.1364H11.0244C11.3554 14.1364 11.6374 14.1996 11.8703 14.326C12.1033 14.451 12.2808 14.625 12.403 14.848C12.5266 15.0696 12.5884 15.3253 12.5884 15.615C12.5884 15.9048 12.5259 16.1605 12.4009 16.3821C12.2759 16.6037 12.0948 16.7763 11.8575 16.8998C11.6217 17.0234 11.3362 17.0852 11.001 17.0852H9.90371V16.3459H10.8519C11.0294 16.3459 11.1757 16.3153 11.2908 16.2543C11.4073 16.1918 11.4939 16.1058 11.5507 15.9964C11.609 15.8856 11.6381 15.7585 11.6381 15.615C11.6381 15.4702 11.609 15.3437 11.5507 15.2358C11.4939 15.1264 11.4073 15.0419 11.2908 14.9822C11.1743 14.9212 11.0266 14.8906 10.8476 14.8906H10.2254V18.5H9.30286Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 21,
					height: 13,
					rx: 2,
					fill: "#14120F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.49858 31V30.1786L9.76491 25.5955H6.49219V24.4545H11.5036V25.2759L8.23402 29.859H11.5099V31H6.49858Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.1357 24.4545V31H12.7518V24.4545H14.1357Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.4543 31V24.4545H18.0367C18.5331 24.4545 18.9561 24.5493 19.3055 24.739C19.6549 24.9265 19.9213 25.1875 20.1045 25.522C20.2899 25.8544 20.3825 26.2379 20.3825 26.6726C20.3825 27.1072 20.2888 27.4908 20.1013 27.8231C19.9138 28.1555 19.6421 28.4144 19.2863 28.5998C18.9326 28.7851 18.5044 28.8778 18.0015 28.8778H16.3556V27.7688H17.7778C18.0441 27.7688 18.2636 27.723 18.4362 27.6314C18.6109 27.5376 18.7409 27.4087 18.8261 27.2447C18.9134 27.0785 18.9571 26.8878 18.9571 26.6726C18.9571 26.4552 18.9134 26.2656 18.8261 26.1037C18.7409 25.9396 18.6109 25.8128 18.4362 25.7233C18.2615 25.6317 18.0399 25.5859 17.7714 25.5859H16.8382V31H15.4543Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FileZipIcon };
